<script>
    import {Link} from "svelte-routing";

    export let href = '#';
</script>

{#if href === '#'}
    <button type="button" class="btn btn-link btn-icon" on:click {...$$restProps}>
        <ion-icon name="add" role="img" class="md hydrated" aria-label="add"></ion-icon>
    </button>
{:else}
    <Link to={href} class="btn btn-link btn-icon" {...$$restProps}>
        <ion-icon name="add" role="img" class="md hydrated" aria-label="add"></ion-icon>
    </Link>
{/if}
